<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Select } from '@drama/ui'
import FormField from '../NovelFormField.vue'
import { useSectionModel } from './section-model.js'

const props = defineProps({
  modelValue: { type: Object, required: true },
  issues: { type: Array, default: () => [] },
  guided: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
})
const emit = defineEmits(['update:modelValue'])
const { t } = useI18n()
const { invalid, write, error } = useSectionModel(props, emit)
const label = computed(() => t(props.guided ? 'novelAuthoring.playerRole' : 'novelStudio.fields.playerCharacter'))
const player_options = computed(() => (props.modelValue.characters ?? [])
  .map(person => ({ value: person.id, label: person.name || person.id })))
</script>

<template>
  <section data-testid="novel-player-section">
    <FormField
      :error="error(['player_id'])"
      required
      :label="label"
      :hint="guided ? t('novelAuthoring.playerRoleHint') : ''"
    >
      <Select
        :model-value="modelValue.player_id ?? ''"
        :options="player_options"
        :aria-label="label"
        :invalid="invalid(['player_id'])"
        :disabled="disabled"
        data-path="player_id"
        block
        @update:model-value="write(['player_id'], $event)"
      />
    </FormField>
  </section>
</template>
